import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { withMask, formatDate, parseDate } from '../InputText';
import { stringToDate, dateToString } from '../../Utils/Date';
import { useId } from '../../Utils/Hooks';

import { DisplayInput } from '../DisplayInput';
import { Popover } from '../Popover';
import { Calendar } from '../../Organisms/Calendar';
import { Icon } from '../Icon';

import * as Styles from './index.styles';

const { StyledContainer } = Styles;

export const MaskedInputDate = withMask(DisplayInput, { format: formatDate, parse: parseDate });

export const DisplayInputDate = ({
    id,
    defaultValue,
    onChange,
    inputRef,
    disabled,
    calendarProps,
    ...otherProps
}) => {
    const [value, setValue] = useState(defaultValue);
    const [open, setOpen] = useState(false);

    const ref = inputRef || useRef();
    const [inputId] = useId('display-input-date', id);

    const onInputChange = evt => {
        const formattedDate = formatDate(evt.target.value);
        const date = stringToDate(formattedDate);
        setValue(formattedDate);
        onChange(formattedDate, date);
    };

    const onCalendarChange = date => {
        const dateAsString = dateToString(date);
        if (dateAsString) {
            setValue(dateAsString);
            setOpen(false);
            onChange(dateAsString, date);
        }
    };

    return (
        <StyledContainer>
            <MaskedInputDate
                id={inputId}
                inputRef={ref}
                value={value}
                onChange={onInputChange}
                icon={
                    <Icon
                        id={`${inputId}-icon`}
                        data-test-id="icon-btn"
                        icon={['far', 'calendar-day']}
                        size="lg"
                        onClick={() => setOpen(!open)}
                    />
                }
                {...otherProps}
            />
            <Popover
                bindTo={`${inputId}-icon`}
                open={!disabled && open}
                onClose={() => setOpen(false)}
                showCloseIcon
            >
                <Calendar
                    defaultDate={value}
                    shadow={false}
                    onChange={onCalendarChange}
                    {...calendarProps}
                />
            </Popover>
        </StyledContainer>
    );
};

DisplayInputDate.propTypes = {
    id: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    inputRef: PropTypes.shape({}),
    disabled: PropTypes.bool,
    calendarProps: PropTypes.shape({}),
};

DisplayInputDate.defaultProps = {
    id: '',
    defaultValue: '',
    onChange: () => null,
    inputRef: null,
    disabled: false,
    calendarProps: {},
};

DisplayInputDate.Styles = Styles;
